import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { EcommService } from './ecomm.service';
import { constApi } from 'src/environments/constApi';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class ItemsService {

  constructor(
    private http: HttpClient,
    private ecommService: EcommService,
    private spinner: NgxSpinnerService,
  ) { }
  itemsList(param) {
    let paramString = '';
    for (let i = 0; i < param.length; i++) {
      if (param[i].valueparam != '' && param[i].valueparam != 'null') {
        paramString += param[i].keyparam + "=" + param[i].valueparam + "&"
      }
    }
    let urlProductos = environment.apiUrl + '/ItemsEC/List?' + paramString;
    return this.http.get(urlProductos);
  }
  // sumarClic(idItem:Number){
  //   this.ecommService
  //   .updateId(constApi.ITEMSECLIC,idItem)
  //   .subscribe((res:any)=> {
  //     // console.log(res)
  //   })
  // }
  async sumarClic(idItem:Number) {
    return await this.ecommService
    .updateId(environment.apiUrl,constApi.ITEMSECLIC, idItem)
      .toPromise()
      .catch((error: any) => {
        this.spinner.hide()
      });
  }
}
